<template>
  <div class="footerContent">
    <img class="img1" src="@/assets/img/footer.png" alt />
    <div class="safeContent">
      <div class="firstPart">
          <div style="margin-top:40px;line-height:30px" >
            <div >联系我们</div>
            <img  style="position:relative;margin-left:-5px;" src="@/assets/img/foot_icon1.png" alt="">
            <div style="margin-top:16px;">商 务 合 作 : 0 2 5 - 5 2 6 3 3 8 8 1</div>
            <div >邮 箱：sales@wch.cn</div>
            <div >苏ICP备15062864号 Copyright © 2002-2019江苏沁恒股份有限公司.All Rights Reserved</div>
          </div>
          <!-- <div style="margin-top:101px;">
            <div style="margin-top:17px;">邮 箱：tech@wch.cn</div>
          </div> -->
        <div  style="margin-top:60px;">
          <img src="@/assets/img/codeImg.png" alt />
          <div style="font-size:14px;">扫二维码&nbsp;关注公众号</div>
        </div>
      </div>
      <!-- <div style="margin-top:63px;width:100%;display:flex;justify-content: space-between;">
        <span >法律声明</span>
        <span>苏ICP备150628362Copyright@ 2002-2019江苏沁恒股份有限公司.All Rights Reserved</span>
      </div> -->
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped lang='scss'>
.footerContent {
  width: 100%;
  position: relative;
  height: 243px;
}
.img1 {
  width: 100%;
  height: 243px;
  position: absolute;
  z-index: -1;
  left: 0;
  right: 0
}
.safeContent {
  width: 1150px;
  margin: 0 auto;
  padding: 0 45px 0  25px;
  color: white;
}
.firstPart {
  height: 130px;
  text-align: left;
  display: flex; 
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue